import admin from './admin'
import guides from './guides'
import applications from './applications'
import auth from './auth'
import { createStore } from 'vuex'
import suivifabrication from './suivifabrication'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  state: {
    navigations: {
      main: [
        { name: `Base de données`, viewName: 'ExercisesList', roles:['Admin','Full','Expert'] },
        { name: `Suivi`, viewName: 'MonitoringHome' , roles:['Admin','Full','Expert']},
        { name: `Etat flotte`, viewName: 'FlotteOxilio', roles:['Admin','Full','OxilioManager']},
        { name: `Lancement`, viewName: 'LancementHome' , roles:['Admin','Full','Expert']},
        { name: `Suivi Fabrication`, viewName: 'SuiviFabrication' , roles:['Admin','Full','Expert']}
      ],
      admin: [
        { name: `Exercices`, viewName: 'ExercisesList' },
        /*{ name: `Familles d'exercices`, viewName: 'ExercisesFamilies' },*/
        { name: `Programmes`, viewName: 'ProgramsList' },
        { name: `Programmes recommandés`, viewName: 'RecommandedProgramsList' },
        { name: `Activités Physiques Adaptées`, viewName: 'ActivitiesList' },
        { name: `Coachings`, viewName: 'CoachingList' },
        { name: `Pathologies & symptômes`, viewName: 'PathologiesList' },
        { name: `Matériel`, viewName: 'EquipmentsList' },
        { name: `Étapes de réglage`, viewName: 'SettingsSteps' },
        { name: `Rangs`, viewName: 'Ranks' },
        { name: `Succès`, viewName: 'Achievements' },
        { name: `Guides`, viewName: 'GuidesList' },
        { name: `Prescripteurs`, viewName: 'PrescribersList' },
        /*{ name: `Proches Familiaux`, viewName: 'FamilyMembersList' },*/
        { name: `Établissements`, viewName: 'EstablishmentsList' }/*,
        { name: `Employés`, viewName: 'EmployeesList' }*/
      ]
    }
  },
  getters: {
    navMain: (state) => {
      return state.navigations.main
    },
    navDatabase: (state) => {
      return state.navigations.admin
    },
    navSuiviFabrication: (state) => {
      return state.navigations.suivifabrication
    }
  },
  modules: {
    auth,
    admin,
    guides,
    applications,
    suivifabrication
  },
  strict: debug
})
